// extracted by mini-css-extract-plugin
module.exports = {"header":"app-header_header__27JyB","wrapper":"app-header_wrapper__1uWk0","logoWrapper":"app-header_logoWrapper__nwPlh","nav":"app-header_nav__2CsKz"};